var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"checkout-section sticky"},[_c('header',{staticClass:"checkout-section__header"},[_c('h2',{staticClass:"checkout-section__header__title"},[_vm._t("header")],2)]),_c('div',{staticClass:"checkout-section__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }